const ViewOwner = () => {
  return (
    <div>
      <h1>View Owner</h1>
    </div>
  );
};

export default ViewOwner;
